import { supabase } from '../../supabase';

function isRpcMissing(error) {
  const msg = String(error?.message || error || '').toLowerCase();
  return (
    msg.includes('could not find the function')
    || msg.includes('function public.get_remaining_payments_page')
    || msg.includes('schema cache')
    || (msg.includes('get_remaining_payments_page') && msg.includes('does not exist'))
  );
}

function cleanFilters(filters = {}) {
  const out = {};
  Object.entries(filters || {}).forEach(([key, value]) => {
    const text = String(value ?? '').trim();
    if (text && text !== 'all' && text !== '—') out[key] = text;
  });
  return out;
}

export async function fetchRemainingPaymentsPageRpc({
  gymId,
  page = 0,
  pageSize = 20000,
  search = '',
  branch = '',
  memberId = null,
  filters = {},
  allMatching = true,
} = {}) {
  if (!gymId) return null;

  const branchValue = String(branch || '').trim();
  const pBranch = !branchValue || branchValue === 'all' ? null : branchValue;
  const mid = String(memberId || '').trim();
  const pMemberId = /^[0-9a-f-]{36}$/i.test(mid) ? mid : null;

  const { data, error } = await supabase.rpc('get_remaining_payments_page', {
    p_gym_id: gymId,
    p_branch: pBranch,
    p_page: allMatching ? 0 : Math.max(1, Number(page) || 1),
    p_page_size: allMatching ? 20000 : Math.min(20000, Math.max(10, Number(pageSize) || 20000)),
    p_search: String(search || '').trim(),
    p_member_id: pMemberId,
    p_filters: cleanFilters(filters),
  });

  if (error) {
    if (isRpcMissing(error)) return null;
    throw error;
  }
  const payload = typeof data === 'string'
    ? (() => { try { return JSON.parse(data); } catch { return null; } })()
    : data;
  if (!payload || payload.error) return null;

  return {
    total: Number(payload.total) || 0,
    leftover: Number(payload.leftover ?? payload.collected) || 0,
    page: Number(payload.page) || 1,
    pageSize: Number(payload.page_size) || pageSize,
    rows: Array.isArray(payload.rows) ? payload.rows : [],
    fromRpc: true,
  };
}
